<template>
  <div>
    <div v-for="(item, index) in formItems" :key="index">
      <template v-if="item.isTypeSection">
        <slot name="section" :section="item">
          <form-section :section="item" />
        </slot>
      </template>
      <template v-if="item.isTypeParagraph">
        <slot name="paragraph" :paragraph="item">
          <form-paragraph :paragraph="item" />
        </slot>
      </template>
      <template v-if="item.isTypeField">
        <slot name="field" :field="item">
          <form-field :field="item" />
        </slot>
      </template>
    </div>

    <template v-if="showConsent && consent.enabled">
      <slot name="consent" :conset="consent">
        <div class="w-full border bg-gray-100 rounded p-4 dark:bg-gray-900">
          <p class="text-md font-medium text-gray-800 mb-1 dark:text-gray-100">
            {{ consent.title }}
          </p>
          <p class="text-sm text-gray-700 dark:text-gray-200">
            {{ consent.content }}
          </p>

          <checkbox-field v-model="_customerForm.consentAccepted" :label="consent.label" class="mt-2" />
        </div>
      </slot>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FormSection from './FormSection.vue'
import FormParagraph from './FormParagraph.vue'
import FormField from './FormField.vue'
import {
  CheckboxField,
} from '@/components/fields'

interface Props {
  customerForm: Record<string, any>
  showConsent?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showConsent: true,
})

const emit = defineEmits<{
  (e: 'update:customerForm', value: Record<string, any>): void
}>()

const _customerForm = computed({
  get () {
    return props.customerForm
  },
  set (value) {
    emit('update:customerForm', value)
  },
})

const formItems = computed(() => {
  return props.customerForm.formItems
})

const consent = computed(() => {
  const form = props.customerForm.form

  return {
    label: form.consentAcceptLabel,
    content: form.consentContent,
    enabled: form.consentEnabled,
    title: form.consentTitle,
  }
})
</script>
